@if (dataLayerToChangePublishStatus) {
  <p-confirmDialog
    key="dataLayerPublicationDialog"
    #cd
    styleClass="w-9"
    appendTo="body"
    [blockScroll]="false">
    <ng-template pTemplate="headless" let-message>
      <div class="p-card border-round pt-1 p-4">
        <app-header
          [icon]="
            dataLayerToChangePublishStatus.published
              ? 'fas fa-house-user'
              : 'fas fa-globe-europe'
          "
          [text]="
            dataLayerToChangePublishStatus.year +
            ' wirklich ' +
            (dataLayerToChangePublishStatus.published
              ? 'intern schalten'
              : 'veröffentlichen') +
            '?'
          "></app-header>

        <p-divider></p-divider>
        @if (layerHasData) {
          <p appAlertStyle="warning" class="p-3">
            <i class="fas fa-exclamation-triangle"></i>

            @if (!dataLayerToChangePublishStatus.published) {
              Dadurch sind alle veröffentlichen Daten innerhalb dieses Jahres
              öffentlich sichtbar.
            } @else {
              Dadurch sind alle Daten (auch veröffentlichte) innerhalb dieses
              Jahres öffentlich nicht mehr sichtbar. Prüfen Sie unbedingt ihre
              Ansichten!
            }
          </p>
          <p-divider></p-divider>
          <app-header
            icon="fas fa-database"
            text="Enthaltene Daten"
            [count]="
              indicatorDataStore.countByDataLayer(
                dataLayerToChangePublishStatus._id
              )
            "></app-header>
          <p-scrollPanel styleClass="h-20rem">
            <app-data-layer-data-list
              [dataLayer]="dataLayerToChangePublishStatus" />
          </p-scrollPanel>
        } @else {
          <app-alert [canToggle]="false" styleClass="p-3">
            <i class="fas fa-circle-info"></i> Diesem Jahr sind keine Daten
            zugeordnet. Es kann sicher gelöscht werden.
          </app-alert>
        }

        <p-divider></p-divider>
        <div class="flex align-items-center gap-3 mt-4">
          <button
            [rounded]="true"
            [outlined]="true"
            severity="secondary"
            pButton
            icon="fas fa-times"
            label="nein, abbrechen"
            (click)="cd.reject()"></button>
          <button
            [rounded]="true"
            pButton
            [icon]="
              dataLayerToChangePublishStatus.published
                ? 'fas fa-globe-europe'
                : 'fas fa-user-house'
            "
            [label]="
              dataLayerToChangePublishStatus.published
                ? 'ja, intern schalten'
                : 'ja, veröffentlichen'
            "
            (click)="cd.accept()"
            class="ml-auto"></button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
}
